module.exports = __webpack_public_path__ + "media/images/home-logo-1562146d1ef0b2af079fcb33144a6acf.png";